import styled, {css} from 'styled-components';

import type {ThemeColor} from '../../../../styles/theme';
import type {StyledProps} from './types';

import CardIcon from '../../../../assets/icons/primary/Card.svg';
import StripeIcon from '../../../../assets/icons/stripe.svg';
import {ms, msi} from '../../../../styles/normalizeSize';
import {getColor, square} from '../../../../styles/utils';
import {Button} from '../../../../uikit/Button';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';

const ICON_CONTAINER_SIZE = msi(40);
const ICON_CONTAINER_MARGIN = msi(16);

export const Container = styled(View)`
  flex-direction: column;
  flex: 1;
`;

export const ContentWrapper = styled(View)`
  align-self: stretch;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

export const LeftSide = styled(View)`
  flex-direction: row;
`;

export const RightSide = styled(View)`
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`;

export const IconContainer = styled(View)`
  ${square(ICON_CONTAINER_SIZE)};

  align-items: center;
  justify-content: center;
  background-color: ${getColor('background2')};
  border-radius: ${ms(20)};
  margin-right: ${ICON_CONTAINER_MARGIN}px;
`;

export const Icon = styled(({type, ...rest}) => {
  const Component = type === 'stripe' ? StripeIcon : CardIcon;

  return <Component {...rest} />;
}).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
`;

export const DateContainer = styled(View)`
  flex-direction: column;
`;

const statusColorStyle = css<StyledProps>`
  ${p => {
    let color: ThemeColor = 'text3';

    switch (p.$statusVariant) {
      case 'failed':
        color = 'error';
        break;
      case 'success':
        color = 'text4';
        break;
      default:
        break;
    }

    return css`
      color: ${getColor(color)};
    `;
  }}
`;

export const Amount = styled(Text)<StyledProps>`
  font-size: ${ms(15)};
  line-height: ${ms(22)};
  letter-spacing: ${ms(-0.41)};
  text-align: right;

  ${statusColorStyle};
`;

export const Date = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${ms(15)};
  line-height: ${ms(22)};
  letter-spacing: ${ms(-0.24)};
`;

export const Status = styled(Text)<StyledProps>`
  font-size: ${ms(13)};
  line-height: ${ms(18)};
  letter-spacing: ${ms(-0.08)};

  ${statusColorStyle};
`;

export const Tax = styled(Text)`
  font-size: ${ms(13)};
  line-height: ${ms(18)};
  letter-spacing: ${ms(-0.08)};
  color: ${getColor('text3')};
  text-align: right;
`;

export const DescriptionContainer = styled(View)`
  margin-top: ${ms(8)};
  background-color: ${getColor('background2')};
  border-radius: ${ms(10)};
  margin-left: ${ICON_CONTAINER_SIZE + ICON_CONTAINER_MARGIN}px;
  padding: ${ms(10)};
`;

export const Description = styled(Text)`
  font-size: ${ms(12)};
  line-height: ${ms(14)};
  letter-spacing: ${ms(-0.41)};
  color: ${getColor('text3')};
`;

export const RetryButton = styled(Button)`
  border-radius: ${ms(10)};
  height: ${ms(30)};
  align-items: center;
  justify-content: center;
  margin-left: ${ICON_CONTAINER_SIZE + ICON_CONTAINER_MARGIN}px;
  margin-top: ${ms(6)};
`;

export const RetryButtonText = styled(Text)`
  font-size: ${ms(12)};
  letter-spacing: ${ms(-0.208)};
  color: ${getColor('text.white')};
`;
